import LoginComponent from '../components/login/login-component'
import RegisterComponent from '../components/register/register-component'
import BackToTopButton from '../components/common/back-to-top-button'
import StickyCartButton from '../components/common/sticky-cart-button'
import Quantity from '../components/quantity/quantity'
import QuantityBtn from '../components/quantity/quantity-btn'
import LocalizationSelector from '../components/localization-selector/localization-selector'
import NotificationComponent from '../components/notification/notification'
import Tabs from '../components/tabs/tabs'
import List from '../components/list/list'
import ListBtn from '../components/list/list-btn'
import FloatElement from '../components/float-element/float-element'
import FloatElementBtn from '../components/float-element/float-element-btn'
import HotspotsFloatElement from '../components/float-element/hotspots-float-element'
import DropdownOpener from '../components/float-element/dropdown-opener'
import TooltipTrigger from '../components/float-element/tooltip-trigger'
import Accordeon from '../components/accordeon/accordeon'
import AccordeonBtn from '../components/accordeon/accordeon-btn'
import ProductMediaTabs from '../components/product-card/product-card-media-tabs'
import ProductCardColorSwatches from '../components/product-card/product-card-color-swatches'
import Modal from '../components/modal/modal'
import PasswordModal from '../components/password-page-modal/password-modal'
import CartNotificationPopup from '../components/common/cart-notification-popup'
import ModalOpener from '../components/modal/modal-opener'
import PasswordModalOpener from '../components/password-page-modal/password-modal-opener'
import ModalCloseBtn from '../components/modal/modal-close-btn'
import SidebarBtn from '../components/sidebar/sidebar-btn'
import Sidebar from '../components/sidebar/sidebar'
import SearchSidebar from '../components/search/search-sidebar'
import QuickViewComponent from '../components/quick-view/quick-view'
import Carousel from '../components/carousel/carousel'
import CarouselPlayButton from '../components/carousel/carousel-play-button'
import CarouselDots from '../components/carousel/carousel-dots'
import CarouselDot from '../components/carousel/carousel-dot'
import CarouselBtn from '../components/carousel/carousel-btn'
import CarouselProgress from '../components/carousel/carousel-progress-bar'
import HeaderComponent from '../components/header/header'
import DrawerMenu from '../components/header/drawer-menu'
import DrawerMenuPage from '../components/header/drawer-menu-page'
import DrawerMenuPageLink from '../components/header/drawer-menu-page-link'
import Pagination from '../components/pagination/pagination'
import PaginationLoadButton from '../components/pagination/pagination-load-button'
import PaginationLink from '../components/pagination/pagination-link'
import PaginationInfiniteScroll from '../components/pagination/pagination-infinite-scroll'
import DeferredMedia from '../components/deffered-media/deffered-media'
import PickupAvailability from '../components/product/product-pickup-availability'
import ProductForm from '../components/product/product-form'
import ProductFormButton from '../components/product/product-form-button'
import ProductBlock from '../components/product/product-block'
import ProductModel from '../components/product/product-model'
import CartItem from '../components/cart/cart-item'
import Cart from '../components/cart/cart'
import CartDrawer from '../components/cart/cart-drawer'
import FreeShippingBar from '../components/cart/free-shipping-bar'
import ProductMedia from '../components/product/product-media'
import ProductMediaCarousel from '../components/product/product-media-carousel'
import VariantPicker from '../components/product/product-variant-picker'
import ColorSwatchesPicker from '../components/product/product-color-swatches'
import ProductModal from '../components/product/product-modal'
import ProductModalImageWrap from '../components/product/product-modal-image-wrap'
import ProductModalOpener from '../components/product/product-modal-opener'
import ProductRecommendations from '../components/product-recommendations/product-recommendations'
import SearchSidebarFormWrapper from '../components/search/search-sidebar-form-wrapper'
import CartRemoveButton from '../components/cart/cart-remove-btn'
import ClipboardButton from '../components/clipboard-button/clipboard-button'
import ClipboardButtonTooltip from '../components/clipboard-button/clipboard-button-tooltip'
import ProductCard from '../components/product-card/product-card'
import MaxLinesComponent from '../components/common/max-lines-component'
import CountrySelector from '../components/country-selector/country-selector'
import SearchField from '../components/form/search-input'
import PasswordField from '../components/form/password-input'
import ZoomCursor from '../components/zoom-cursor/zoom-cursor'
import Shop from '../components/shop/shop'
import ShopActiveFilters from '../components/shop/shop-active-filters'
import SidebarFiltersDesktop from '../components/filters/sidebar-filters-desktop'
import SidebarFiltersMobile from '../components/filters/sidebar-filters-mobile'
import FilterRemoveBtn from '../components/filters/filter-remove-btn'
import SortList from '../components/sort-list/sort-list'
import PriceRange from '../components/shop/price-range'
import ColumnSwitcher from '../components/column-switcher/column-switcher'
import FiltersSubmitBtn from '../components/filters/filters-submit-btn'
import BeforeAfterImages from '../components/before-after-images/before-after-images'
import Hotspots from '../components/hotspots/index'
import CountdownTimer from '../components/countdown-timer/countdown-timer'
import ProductInformationDrawer from '../components/product/product-information-drawer'
import Tab from '../components/tabs/tab'
import MobileFiltersStickyButton from '../components/filters/sidebar-filters-mobile-sticky-button'
import RecentlyViewed from '../components/recently-viewed/recently-viewed'
import RecipientForm from '../components/recipient-form/index'
import CollectionCard from '../components/collection-card/collection-card'
import ArticleCard from '../components/article-card/article-card'
import ShapeSwatch from '../components/shape-swatch/shape-swatch'
import HorizontalProductCard from '../components/product-card/horizontal-product-card'
import VerticalProductCard from '../components/product-card/vertical-product-card'
import ProductRelatedBlock from '../components/product-recommendations/related-products-block'
import CustomerAddresses from '../components/addresses/index'
import TabWithDynamicHeight from '../components/tabs/tab-with-dynamic-height'
import VideoBanner from '../components/video-banner/index'
import CartDrawerRelatedProducts from '../components/product-recommendations/cart-drawer-related-products'
import CartDrawerItemsBlock from '../components/cart/cart-drawer-items-block'
import CartDrawerInCartBannerBlock from '../components/cart/cart-drawer-in-cart-banner-block'
import CartDrawerRelatedProductsBlock from '../components/cart/cart-drawer-related-products-block'
import CartDrawerTimerBlock from '../components/cart/cart-drawer-timer-block'
import CartDrawerHeader from '../components/cart/cart-drawer-header'
import CartDrawerFooter from '../components/cart/cart-drawer-footer'
import CartItemsBlock from '../components/cart/cart-items-block'
import CartButtonsBlock from '../components/cart/cart-buttons-block'
import CartCountdownBlock from '../components/cart/cart-countdown-block'
import CartRelatedProductsBlock from '../components/cart/cart-related-products-block'
import CartOrderNotesBlock from '../components/cart/cart-order-notes-block'
import CartNote from '../components/cart/cart-note'
import CartAppBlock from '../components/cart/cart-app-block'
import CartInCartBannerBlock from '../components/cart/cart-in-cart-banner-block'
import CartSubtotalBlock from '../components/cart/cart-subtotal-block'
import CartFreeShippingBarBlock from '../components/cart/cart-free-shipping-bar-block'
import CartCount from '../components/cart/cart-count'
import CartDrawerFreeShippingBarBlock from '../components/cart/cart-drawer-free-shipping-bar-block'
import CartDrawerButtonsBlock from '../components/cart/cart-drawer-buttons-block'
import CartRelatedProducts from '../components/cart/cart-related-products'
import ShareWrapper from '../components/share/share-wrapper'
import ShareComponent from '../components/share/share-component'
import AccordeonContainer from '../components/accordeon/accordeon-container'
import ScrollingText from '../components/scrolling-text/scrolling-text'
import ScrollingTextLine from '../components/scrolling-text/scrolling-text-line'
import CollapsedTags from '../components/collapsed-tags/collapsed-tags'
import ArticleTags from '../components/article-tags/article-tags'
import {
  PopupAgeVerifier,
  PopupCookie,
  PopupSignup,
  PopupPromo,
} from '../components/popups/index'
import Lookbook from '../components/lookbook/index'
import LookbookModal from '../components/lookbook/lookbook-modal'
import StoreLocator from '../components/store-locator/index'
import Map from '../components/map-component/index'
import ProductContent from '../components/product/product-content'
import ProductDetails from '../components/product/product-details'

interface Component {
  tag: string
  component: any
}

const components: Component[] = [
  { tag: 'login-component', component: LoginComponent },
  { tag: 'register-component', component: RegisterComponent },
  { tag: 'back-to-top-button', component: BackToTopButton },
  { tag: 'sticky-cart-button', component: StickyCartButton },
  { tag: 'quantity-component', component: Quantity },
  { tag: 'quantity-btn', component: QuantityBtn },
  { tag: 'localization-selector', component: LocalizationSelector },
  { tag: 'notification-component', component: NotificationComponent },
  { tag: 'tabs-component', component: Tabs },
  { tag: 'tab-component', component: Tab },
  { tag: 'list-component', component: List },
  { tag: 'list-btn', component: ListBtn },
  { tag: 'float-element', component: FloatElement },
  { tag: 'hotspots-float-element', component: HotspotsFloatElement },
  { tag: 'float-element-btn', component: FloatElementBtn },
  { tag: 'dropdown-opener', component: DropdownOpener },
  { tag: 'tooltip-trigger', component: TooltipTrigger },
  { tag: 'accordeon-container', component: AccordeonContainer },
  { tag: 'accordeon-component', component: Accordeon },
  { tag: 'accordeon-btn', component: AccordeonBtn },
  { tag: 'product-media-tabs', component: ProductMediaTabs },
  { tag: 'color-swatches', component: ProductCardColorSwatches },
  { tag: 'modal-component', component: Modal },
  { tag: 'password-modal', component: PasswordModal },
  { tag: 'cart-notification-popup', component: CartNotificationPopup },
  { tag: 'modal-opener', component: ModalOpener },
  { tag: 'password-modal-opener', component: PasswordModalOpener },
  { tag: 'modal-close-btn', component: ModalCloseBtn },
  { tag: 'sidebar-button', component: SidebarBtn },
  { tag: 'sidebar-component', component: Sidebar },
  { tag: 'search-sidebar', component: SearchSidebar },
  { tag: 'quick-view', component: QuickViewComponent },
  { tag: 'carousel-component', component: Carousel },
  { tag: 'carousel-play-button', component: CarouselPlayButton },
  { tag: 'carousel-dots', component: CarouselDots },
  { tag: 'carousel-dot', component: CarouselDot },
  { tag: 'carousel-btn', component: CarouselBtn },
  { tag: 'carousel-progress', component: CarouselProgress },
  { tag: 'header-component', component: HeaderComponent },
  { tag: 'drawer-menu', component: DrawerMenu },
  { tag: 'drawer-menu-page', component: DrawerMenuPage },
  { tag: 'drawer-menu-page-link', component: DrawerMenuPageLink },
  { tag: 'pagination-component', component: Pagination },
  { tag: 'pagination-load-button', component: PaginationLoadButton },
  { tag: 'pagination-link', component: PaginationLink },
  { tag: 'pagination-infinite-scroll', component: PaginationInfiniteScroll },
  { tag: 'deferred-media', component: DeferredMedia },
  { tag: 'pickup-availability', component: PickupAvailability },
  { tag: 'product-form', component: ProductForm },
  { tag: 'product-form-button', component: ProductFormButton },
  { tag: 'product-details', component: ProductDetails },
  { tag: 'product-block', component: ProductBlock },
  { tag: 'product-model', component: ProductModel },
  { tag: 'cart-item', component: CartItem },
  { tag: 'cart-page', component: Cart },
  { tag: 'cart-drawer', component: CartDrawer },
  { tag: 'free-shipping-bar', component: FreeShippingBar },
  { tag: 'product-content', component: ProductContent },
  { tag: 'product-media', component: ProductMedia },
  { tag: 'product-media-carousel', component: ProductMediaCarousel },
  { tag: 'variant-picker', component: VariantPicker },
  { tag: 'color-swatches-picker', component: ColorSwatchesPicker },
  { tag: 'product-modal', component: ProductModal },
  { tag: 'product-modal-image-wrap', component: ProductModalImageWrap },
  { tag: 'product-modal-opener', component: ProductModalOpener },
  { tag: 'product-recommendations', component: ProductRecommendations },
  { tag: 'product-related-block', component: ProductRelatedBlock },
  { tag: 'cart-drawer-related-products', component: CartDrawerRelatedProducts },
  { tag: 'recently-viewed', component: RecentlyViewed },
  { tag: 'search-sidebar-form-wrapper', component: SearchSidebarFormWrapper },
  { tag: 'cart-remove-button', component: CartRemoveButton },
  { tag: 'clipboard-button', component: ClipboardButton },
  { tag: 'clipboard-button-tooltip', component: ClipboardButtonTooltip },
  { tag: 'product-card', component: ProductCard },
  { tag: 'horizontal-product-card', component: HorizontalProductCard },
  { tag: 'vertical-product-card', component: VerticalProductCard },
  { tag: 'max-lines-component', component: MaxLinesComponent },
  { tag: 'country-selector', component: CountrySelector },
  { tag: 'search-field', component: SearchField },
  { tag: 'password-field', component: PasswordField },
  { tag: 'zoom-cursor', component: ZoomCursor },
  { tag: 'shop-component', component: Shop },
  { tag: 'shop-active-filters', component: ShopActiveFilters },
  { tag: 'sidebar-filters-desktop', component: SidebarFiltersDesktop },
  { tag: 'sidebar-filters-mobile', component: SidebarFiltersMobile },
  { tag: 'filter-remove-btn', component: FilterRemoveBtn },
  { tag: 'sort-list', component: SortList },
  { tag: 'price-range', component: PriceRange },
  { tag: 'column-switcher', component: ColumnSwitcher },
  { tag: 'filters-submit-btn', component: FiltersSubmitBtn },
  { tag: 'before-after-images', component: BeforeAfterImages },
  { tag: 'countdown-timer', component: CountdownTimer },
  {
    tag: 'product-information-drawer',
    component: ProductInformationDrawer,
  },
  {
    tag: 'sidebar-filters-sticky-mobile-button',
    component: MobileFiltersStickyButton,
  },
  { tag: 'recipient-form', component: RecipientForm },
  { tag: 'collection-card', component: CollectionCard },
  { tag: 'article-card', component: ArticleCard },
  { tag: 'shape-swatch', component: ShapeSwatch },
  { tag: 'addresses-component', component: CustomerAddresses },
  { tag: 'tab-with-dynamic-height', component: TabWithDynamicHeight },
  { tag: 'video-banner', component: VideoBanner },
  { tag: 'cart-drawer-items-block', component: CartDrawerItemsBlock },
  {
    tag: 'cart-drawer-in-cart-banner-block',
    component: CartDrawerInCartBannerBlock,
  },
  {
    tag: 'cart-drawer-related-products-block',
    component: CartDrawerRelatedProductsBlock,
  },
  { tag: 'cart-drawer-timer-block', component: CartDrawerTimerBlock },
  { tag: 'cart-drawer-header', component: CartDrawerHeader },
  { tag: 'cart-drawer-footer', component: CartDrawerFooter },
  { tag: 'cart-items-block', component: CartItemsBlock },
  { tag: 'cart-buttons-block', component: CartButtonsBlock },
  { tag: 'cart-countdown-block', component: CartCountdownBlock },
  { tag: 'cart-related-products-block', component: CartRelatedProductsBlock },
  { tag: 'cart-order-notes-block', component: CartOrderNotesBlock },
  { tag: 'cart-note', component: CartNote },
  { tag: 'cart-app-block', component: CartAppBlock },
  { tag: 'cart-subtotal-block', component: CartSubtotalBlock },
  { tag: 'cart-in-cart-banner-block', component: CartInCartBannerBlock },
  { tag: 'cart-free-shipping-bar-block', component: CartFreeShippingBarBlock },
  { tag: 'cart-count', component: CartCount },
  {
    tag: 'cart-drawer-free-shipping-bar-block',
    component: CartDrawerFreeShippingBarBlock,
  },
  { tag: 'cart-drawer-buttons-block', component: CartDrawerButtonsBlock },
  { tag: 'cart-related-products', component: CartRelatedProducts },
  { tag: 'share-wrapper', component: ShareWrapper },
  { tag: 'share-component', component: ShareComponent },
  { tag: 'scrolling-text', component: ScrollingText },
  { tag: 'scrolling-text-line', component: ScrollingTextLine },
  { tag: 'hotspots-component', component: Hotspots },
  { tag: 'collapsed-tags', component: CollapsedTags },
  { tag: 'article-tags', component: ArticleTags },
  { tag: 'popup-age-verifier', component: PopupAgeVerifier },
  { tag: 'popup-cookie', component: PopupCookie },
  { tag: 'popup-promo', component: PopupPromo },
  { tag: 'popup-signup', component: PopupSignup },
  { tag: 'lookbook-component', component: Lookbook },
  { tag: 'lookbook-modal', component: LookbookModal },
  { tag: 'map-component', component: Map },
  { tag: 'store-locator', component: StoreLocator },
]

// @ts-expect-error
window.recentlyViewed = RecentlyViewed

const defineComponents = (): void => {
  components.forEach(({ tag, component }) => {
    customElements.define(tag, component)
  })
}

export default defineComponents
